var _path, _path2, _path3, _path4, _path5, _path6, _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgSpeed(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.196 8.265a9.691 9.691 0 00-5.47-4.643A10.395 10.395 0 004.743 9.676c-.79 1.999-.89 4.205-.281 6.267a1.993 1.993 0 001.097 1.248 2.068 2.068 0 001.716 0 2.05 2.05 0 001.087-2.432 5.609 5.609 0 01.183-3.603 6.322 6.322 0 017.862-3.677 5.593 5.593 0 013.306 2.937l.37.793 2.507-1.16a1.31 1.31 0 00.607-1.784z",
    fill: "url(#".concat(_id, ")")
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.154 8.512l-8.78 2.85a1 1 0 00-.559 1.453l.688 1.187.684 1.188a1.001 1.001 0 001.536.244l6.86-6.181a.437.437 0 00-.429-.74z",
    fill: "#79C8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.503 17.468a3.466 3.466 0 100-6.93 3.466 3.466 0 000 6.93z",
    fill: "#5994B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.568.615A13.929 13.929 0 0014.58 0C6.976-.043.598 6.214.5 13.816c-.041 2.635.67 5.227 2.05 7.472a2.115 2.115 0 001.784.999h3.604a.876.876 0 100-1.751H4.57a.754.754 0 01-.656-.367 12.046 12.046 0 01-1.663-6.195C2.259 8.203 7.161 2.59 12.874 1.856A12.265 12.265 0 0126.748 14a12.13 12.13 0 01-1.663 6.169.757.757 0 01-.656.367h-3.367a.876.876 0 000 1.751h3.615a2.099 2.099 0 001.784-.999A14.01 14.01 0 0018.568.615z",
    fill: "#79C8F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.86 26.302A1.7 1.7 0 0124.16 28H4.885a1.702 1.702 0 110-3.404H24.16a1.685 1.685 0 011.198.498 1.708 1.708 0 01.5 1.208z",
    fill: "#F28484"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.569.615l-.708 1.618a12.27 12.27 0 00-4.987-.377C7.16 2.59 2.259 8.203 2.25 13.974a12.046 12.046 0 001.663 6.195.755.755 0 00.657.367h3.367a.876.876 0 010 1.751H4.324a2.116 2.116 0 01-1.784-.999A13.858 13.858 0 01.5 13.816C.598 6.214 6.976-.043 14.58 0c1.352.01 2.696.218 3.989.615z",
    fill: "#8CD7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.142 24.596L12.716 28H4.885a1.702 1.702 0 110-3.404h9.257z",
    fill: "#FA9898"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 4.067,
    y1: 10.223,
    x2: 23.341,
    y2: 10.223,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADC98"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9898"
  })))));
}
export default SvgSpeed;